import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	fill: "none",
	stroke: "#595959",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M2.783 20.25l18.75-18M8.964 18.301c.983.305 2.007.457 3.036.449 4.1.069 8.258-2.813 10.824-5.637.57-.633.57-1.593 0-2.226A20.57 20.57 0 0 0 19.75 8.13m-5.337-2.598A9.55 9.55 0 0 0 12 5.25c-4.031-.067-8.2 2.752-10.821 5.635-.57.633-.57 1.593 0 2.226a20.8 20.8 0 0 0 2.6 2.4M8.25 12A3.75 3.75 0 0 1 12 8.25" }),
		/* @__PURE__ */ _jsx("path", { d: "M15.75 11.999h0A3.75 3.75 0 0 1 12 15.75" })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2225%22%20height%3D%2224%22%20fill%3D%22none%22%20stroke%3D%22%23595959%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22M2.783%2020.25l18.75-18M8.964%2018.301c.983.305%202.007.457%203.036.449%204.1.069%208.258-2.813%2010.824-5.637.57-.633.57-1.593%200-2.226A20.57%2020.57%200%200%200%2019.75%208.13m-5.337-2.598A9.55%209.55%200%200%200%2012%205.25c-4.031-.067-8.2%202.752-10.821%205.635-.57.633-.57%201.593%200%202.226a20.8%2020.8%200%200%200%202.6%202.4M8.25%2012A3.75%203.75%200%200%201%2012%208.25%22%2F%3E%3Cpath%20d%3D%22M15.75%2011.999h0A3.75%203.75%200%200%201%2012%2015.75%22%2F%3E%3C%2Fsvg%3E";
